import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close--sprite",
  "use": "close--sprite-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close--sprite\">\n    <path fill=\"currentColor\" d=\"M0 24C0 10.7452 10.7453 0 24.0001 0C37.2549 0 48.0002 10.7452 48.0002 24C48.0002 37.2548 37.2549 48 24.0001 48C10.7453 48 0 37.2548 0 24Z\" />\n    <path d=\"M33.3334 16.5467L31.4534 14.6667L24 22.1201L16.5467 14.6667L14.6667 16.5467L22.12 24.0001L14.6667 31.4534L16.5467 33.3334L24 25.8801L31.4534 33.3334L33.3334 31.4534L25.88 24.0001L33.3334 16.5467Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol